export default __webpack_public_path__ + "images/folder-KdGx9.png";